import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-error-message',
  templateUrl: './custom-error-message.component.html',
  styleUrls: ['./custom-error-message.component.scss']
})
export class CustomErrorMessageComponent implements OnInit {

  constructor() { }
  @Input() message = '';
  @Input() isClassPresent = '';
  @Input() isShowCloseMark = false;
  @Output() closeClick = new EventEmitter<any>()
  ngOnInit(): void {
  }
  closeErrorMessage(){
    this.closeClick.emit();
  }
}
